export type StatusIllustrationVersion = 'v1' | 'v2';

export enum StatusIllustrationStatus {
    AccessDenied = 'access-denied',
    BadRequest = 'bad-request',
    Created = 'created',
    Empty = 'empty',
    NotFound = 'not-found',
    NoSearchResults = 'no-search-results',
    InternalError = 'internal-error',
}

export enum StatusIllustrationScope {
    Alb = 'alb',
    Billing = 'billing',
    CloudDesktop = 'cloud-desktop',
    Compute = 'compute',
    DataTransfer = 'data-transfer',
    Deploy = 'deploy',
    Dns = 'dns',
    Generic = 'generic',
    Gitlab = 'gitlab',
    Iam = 'iam',
    IotCore = 'iot-core',
    K8s = 'k8s',
    LoadTesting = 'load-testing',
    Logbroker = 'logbroker',
    Logging = 'logging',
    Mdb = 'mdb',
    MessageQueue = 'message-queue',
    Smartcaptcha = 'smartcaptcha',
    Support = 'support',
    Ydb = 'ydb',
    Yql = 'yql',
}

export enum AlbEntity {
    BackendGroups = 'backend-groups',
    Backends = 'backends',
    HealthChecks = 'health-checks',
    HttpRouters = 'http-routers',
    Listeners = 'listeners',
    LoadBalancers = 'load-balancers',
    TargetGroups = 'target-groups',
    Targets = 'targets',
    VirtualHosts = 'virtual-hosts',
    Generic = 'generic',
}

export enum BillingEntity {
    Account = 'account',
    Detail = 'detail',
    Graph = 'graph',
    Resource = 'resource',
    Generic = 'generic',
}

export enum CloudDesktopEntity {
    Desktops = 'desktops',
    LogRecords = 'log-records',
    Generic = 'generic',
}

export enum ComputeEntity {
    Coi = 'coi',
    Console = 'console',
    Disk = 'disk',
    DiskPlacementGroup = 'disk-placement-group',
    Filesystem = 'filesystem',
    Host = 'host',
    HostGroup = 'host-group',
    Image = 'image',
    Instance = 'instance',
    InstanceGroup = 'instance-group',
    InstancePlacementGroup = 'instance-placement-group',
    Log = 'log',
    Network = 'network',
    Schedule = 'schedule',
    Serial = 'serial',
    Snapshot = 'snapshot',
    Generic = 'generic',
}

export enum DataTransferEntity {
    BadRequest = 'bad-request',
    Endpoints = 'endpoints',
    Logs = 'logs',
    Transfers = 'transfers',
    Generic = 'generic',
}

export enum DeployEntity {
    Account = 'account',
    Project = 'project',
    Generic = 'generic',
}

export enum DnsEntity {
    Records = 'records',
    Zones = 'zones',
    Generic = 'generic',
}

export enum GenericEntity {
    Chart = 'chart',
    Directory = 'directory',
    Generic = 'generic',
    Operation = 'operation',
    Query = 'query',
}

export enum GitlabEntity {
    Instances = 'instances',
    OmniAuth = 'omni-auth',
    Generic = 'generic',
}

export enum IamEntity {
    Subject = 'subject',
    Generic = 'generic',
}

export enum IotCoreEntity {
    Broker = 'broker',
    Certificate = 'certificate',
    Device = 'device',
    Password = 'password',
    Registry = 'registry',
    Generic = 'generic',
}

export enum K8sEntity {
    Clusters = 'clusters',
    NodeGroups = 'node-groups',
    Generic = 'generic',
}

export enum LoadTestingEntity {
    Agents = 'agents',
    Buckets = 'buckets',
    Tests = 'tests',
    Generic = 'generic',
}

export enum LogbrokerEntity {
    Account = 'account',
    Consumer = 'consumer',
    Directory = 'directory',
    Generic = 'generic',
    Partition = 'partition',
    Preview = 'preview',
    ReadMetric = 'read-metric',
    Topic = 'topic',
}

export enum LoggingEntity {
    Logs = 'logs',
    Generic = 'generic',
}

export enum MdbEntity {
    Auth = 'auth',
    Backups = 'backups',
    Clusters = 'clusters',
    Connectors = 'connectors',
    Databases = 'databases',
    Datalens = 'datalens',
    DatalensAccess = 'datalens-access',
    Dictionaries = 'dictionaries',
    Dictionary = 'dictionary',
    Explore = 'explore',
    FormatSchemas = 'format-schemas',
    Hosts = 'hosts',
    Jobs = 'jobs',
    Logs = 'logs',
    MlModels = 'ml-models',
    Network = 'network',
    PerformanceDiagnostics = 'performance-diagnostics',
    PerformanceDiagnosticsSessions = 'performance-diagnostics-sessions',
    PerformanceDiagnosticsStatements = 'performance-diagnostics-statements',
    Profilling = 'profilling',
    Shards = 'shards',
    Topics = 'topics',
    Users = 'users',
    Generic = 'generic',
}

export enum MessageQueueEntity {
    Queue = 'queue',
    Generic = 'generic',
}

export enum SmartcaptchaEntity {
    CaptchaSettingsList = 'captcha-settings-list',
    Generic = 'generic',
}

export enum SupportEntity {
    Reply = 'reply',
    Tickets = 'tickets',
    Generic = 'generic',
}

export enum YdbEntity {
    Backup = 'backup',
    Database = 'database',
    Generic = 'generic',
}

export enum YqlEntity {
    Generic = 'generic',
}

export type IllustrationSizeMap = {
    s: number;
    m: number;
    l: number;
    promo: number;
};
